<template>
    <div class="workshops pure-g" :data-grid="grid">

        <div v-if="isLoading" class="pure-u-1 loadingArea"><div class="loading small"></div></div>
        <div v-if="!isLoading && workshops.length === 0" class="pure-u-1"><p class="empty">No workshops here yet.</p></div>

        <router-link v-for="(workshop, workshopIndex) in workshops" :key="workshop.uid" :to="`/workshops/${workshop.uid}`" class="pure-u-1 pure-u-md-1-2 workshopItem" :class="getDynamicClass(workshopIndex)">
            <div class="workshop image" :style="{'backgroundImage': 'url('+ workshop.data.poster.url +')','backgroundPosition': 'center '+ workshop.data.poster_position}">
                
                <span class="badge error" v-if="workshop.data.workshop_status === 'Cancelled'">Cancelled</span>
                <span class="badge grey" v-else-if="workshop.status === 'Finished'" :class="{error: workshop.status === 'Finished'}">{{ workshop.status }}</span>
                <span class="badge" v-if="workshop.workshop_type === 'Private'">{{ workshop.workshop_type}}</span>

                <div class="workshop_wrapper" :class="workshop.data.title_color">
                    <div class="workshop_wrapper_dimmer">
                        <h2>{{ workshop.data.title[0].text }}</h2>
                        <p>{{ workshop.dateTimeTitle }}</p>
                        <div v-if="workshop.members !== null" class="workshop_members">
                            <template v-for="(member, memberIndex) in workshop.members">
                                <div
                                    :key="memberIndex"
                                    class="avatar small"
                                    :style="{backgroundImage: 'url('+ member.photoURL +')', zIndex: workshop.members.length - memberIndex}"
                                    v-if="memberIndex < 11"
                                ></div>
                            </template>
                            <div
                                v-if="workshop.members.length > 11"
                                class="avatar small number"
                                :style="{ zIndex: 1 }"
                            >
                                +{{ workshop.members.length - 11 }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="workshop.data.video_url !== null && workshop.data.show_video" class="backgroundVideo">
                    <video :src="workshop.data.video_url.url" muted autoplay loop playsinline></video>
                </div>
            </div>
        </router-link>

    </div>
</template>

<script>
const fb = require('@/firebaseConfig.js')
import moment from 'moment'

export default {
    data(){
        return{
            allWorkshopsObj: {},
            allWorkshops: [],
            allPastWorkshops: [],
            allPrivateWorkshops: [],
            allPrivatePastWorkshops: [],
            workshops: [],
            workshopMembers: {},
            isLoading: false
        }
    },

    props: {
        'grid': String,
        'type': String,
        'max': Number,
        'userId': String
    },

    mounted(){
        this.getAllWorkshops()
    },

    methods: {
        isWorkshopActive(workshop){

            let workshopState = false
            let today = moment()
            let start_date = moment(workshop.data.date_and_time)
            let end_date = null

            // Workshop has end date
            if(workshop.data.date_and_time_to !== null){

                end_date = moment(workshop.data.date_and_time_to)

                if(today.isBefore(start_date)){
                    workshopState = true
                }
                if(today.isAfter(start_date) && today.isBefore(end_date)){
                    workshopState = true
                }
                if(today.isAfter(end_date)){
                    workshopState = false
                }

            // Workshop has no end date
            }else{
                if(today.isAfter(end_date)){
                    workshopState = false
                }
            }

            return workshopState
        },
        getWorkshopDateTitle(workshop){

            let workshopDateTitle = ''
            let start_date = moment(workshop.data.date_and_time)
            let end_date = null

            // Workshop has end date
            if(workshop.data.date_and_time_to !== null){

                end_date = moment(workshop.data.date_and_time_to)
                let days = end_date.diff(start_date, 'days')

                if(days === 0){
                    workshopDateTitle = start_date.format('MMM DD - h:mm a')
                }else{
                    workshopDateTitle = start_date.format('MMM DD') + ' - ' + end_date.format('MMM DD') + ' ('+ days +' days)'
                }

            // Workshop has no end date
            }else{
                workshopDateTitle = start_date.format('MMM DD - h:mm a')
            }

            // Timezone
            if(typeof(workshop.data.timezone) !== 'undefined'){
                if(workshop.data.timezone.length > 0){
                    if(typeof(workshop.data.timezone[0].text) !== 'undefined'){
                        if(workshop.data.timezone[0].text !== ''){
                            workshopDateTitle += ' ('+ workshop.data.timezone[0].text +')'
                        }
                    }
                }
            }

            return workshopDateTitle
        },
        async getWorkshopMembers(workshopId){

            let self = this
            let workshopRef = fb.workshopsCollection.doc(workshopId).collection('members')
            let workshopMembers = []

            return workshopRef.get().then(snap => {

                snap.forEach(member => {
                    workshopMembers.push(this.$store.state.allUsers[member.id])
                })
                
                return workshopMembers
                
            }).catch(err => {
                console.log('Error getting workshop members: ', err)
                return []
            })
        },
        getAllWorkshops(){

            // console.log('Workshop location: ', this.$store.state.location)

            let self = this
            self.isLoading = true
            
            let defaultLocation = this.$store.state.location.city

            this.$prismic.client.query(
                this.$prismic.Predicates.at('document.type', 'workshops'),
                {
                    orderings: '[my.workshops.date_and_time_to, my.workshops.date_and_time]'
                }
            ).then((response) => {

                let allActiveWorkshops = []
                let allFinishedWorkshops = []
                let allPrivateActiveWorkshops = []
                let allPrivateFinishedWorkshops = []

                // console.log('All Workshops: ', response.results)

                response.results.forEach(function(workshop){

                    // Filter all city workshops
                    let addWorkshop = true

                    if(workshop.data.default_location.length > 0){
                        if(workshop.data.default_location[0].text !== ''){
                            if(workshop.data.default_location[0].text !== defaultLocation){
                                addWorkshop = false
                            }   
                        }
                    }
                    
                    if(addWorkshop){
                        self.allWorkshopsObj[workshop.uid] = workshop
                        let dateTimeTitle = self.getWorkshopDateTitle(workshop)
                        self.allWorkshopsObj[workshop.uid].dateTimeTitle = dateTimeTitle
                        workshop.dateTimeTitle = dateTimeTitle

                        if(self.isWorkshopActive(workshop)){
                            workshop.status = 'Active'
                            self.allWorkshopsObj[workshop.uid].status = 'Active'

                            if(workshop.data.workshop_type === 'Private'){
                                allPrivateActiveWorkshops.push(workshop)
                                console.log('Private active workshop: ', workshop)
                            }else{
                                allActiveWorkshops.push(workshop)
                            }
                        }else{
                            workshop.status = 'Finished'
                            self.allWorkshopsObj[workshop.uid].status = 'Finished'

                            if(workshop.data.workshop_type === 'Private'){
                                allPrivateFinishedWorkshops.push(workshop)
                            }else{
                                allFinishedWorkshops.push(workshop)
                            }
                        }
                    }
                })

                // Finished workshops
                allFinishedWorkshops.reverse()
                self.allPastWorkshops = allFinishedWorkshops
                allPrivateFinishedWorkshops.reverse()
                self.allPrivatePastWorkshops = allPrivateFinishedWorkshops

                if(self.type === 'latest'){

                    if(self.max === null){
                        return allActiveWorkshops
                    }else{
                        return allActiveWorkshops.slice(0, self.max)
                    }

                }else if(self.type === 'past'){

                    if(self.max === null){
                        return allFinishedWorkshops
                    }else{
                        return allFinishedWorkshops.slice(0, self.max)
                    }

                }else if(self.type === 'latestOrPast'){

                    let itemsToReturn = []

                    if(self.max === null){
                        itemsToReturn = allActiveWorkshops
                    }else{
                        itemsToReturn = allActiveWorkshops.slice(0, self.max)
                    }
                    if(itemsToReturn.length === 0){
                        if(self.max === null){
                            itemsToReturn = allFinishedWorkshops
                        }else{
                            itemsToReturn = allFinishedWorkshops.slice(0, self.max)
                        }
                    }

                    return itemsToReturn

                }else if(self.type === 'private'){

                    allPrivateActiveWorkshops.concat(allPrivateFinishedWorkshops)

                    if(self.max === null){
                        return allPrivateActiveWorkshops
                    }else{
                        return allPrivateActiveWorkshops.slice(0, self.max)
                    }

                }else if(self.type === 'userJoined'){
                    return this.getUserJoinedWorkshops()
                }else if(self.type === 'userSaved'){
                    return this.getUserSavedWorkshops()
                }
            }).then(allWorkshops => {

                let self = this
                let allFinalWorkshops = []

                if(allWorkshops !== null){
                    if(allWorkshops.length > 0){
                        allWorkshops.forEach(async(workshop, workshopIndex) => {
                            
                            let workshopMembers = await self.getWorkshopMembers(workshop.uid)
                            
                            workshop.members = workshopMembers
                            allFinalWorkshops.push(workshop)

                            if(workshopIndex === allWorkshops.length - 1){
                                self.workshops = allFinalWorkshops
                                self.isLoading = false

                                // console.log('All Workshops: ', allWorkshops)
                            }
                        })
                    }else{

                        self.workshops = allFinalWorkshops
                        self.isLoading = false
                    }
                }else{

                    self.workshops = allFinalWorkshops
                    self.isLoading = false
                }
            })
        },
        getUserJoinedWorkshops(){

            let self = this
            let userId = ''

            if(this.userId){
                userId = this.userId
            }else{
                userId = this.$store.state.currentUser.uid
            }

            let userJoinedWorkshops = fb.usersCollection.doc(userId).collection('joinedWorkshops')

            return userJoinedWorkshops.get().then(function(snap){

                let userJoinedWorkshopsList = []

                snap.forEach(function(workshop){
                    if(workshop.exists){
                        if(self.allWorkshopsObj[workshop.id] !== null && typeof(self.allWorkshopsObj[workshop.id]) !== 'undefined'){
                            let workshopData = self.allWorkshopsObj[workshop.id]
                            userJoinedWorkshopsList.push(workshopData)
                        }
                    }
                })

                // Sort Joined Workshops by Date
                userJoinedWorkshopsList.sort((a, b) => {
                    let keyA = new Date(b.data.date_and_time)
                    let keyB = new Date(a.data.date_and_time)

                    if(keyA < keyB) return -1
                    if(keyA > keyB) return 1
                    return 0
                })

                return userJoinedWorkshopsList

            }).catch(err => {

                console.log('Error getting all workshops')
                return []
            })
        },
        getUserSavedWorkshops(){

            let self = this
            let userSavedWorkshops = fb.usersCollection.doc(this.$store.state.currentUser.uid).collection('savedWorkshops')

            return userSavedWorkshops.get().then(function(snap){
                
                let userSavedWorkshopsList = []

                snap.forEach(function(workshop){
                    if(workshop.exists){
                        if(self.allWorkshopsObj[workshop.id] !== null && typeof(self.allWorkshopsObj[workshop.id]) !== 'undefined'){
                            
                            let workshopData = self.allWorkshopsObj[workshop.id]

                            console.log('Workshop: ', workshop.id, workshopData)

                            userSavedWorkshopsList.push(workshopData)
                        }
                    }
                })

                return userSavedWorkshopsList

            }).catch(err => {
                
                console.log('Error getting user saved workshops: ', err.message)
                return []
            })

        },
        getDynamicClass(index){

            let classes = ''

            if(this.grid === '3'){
                if(index === 3 || index === 6){
                    classes = 'pure-u-lg-2-3 full'
                }else{
                    classes = 'pure-u-lg-1-3'
                }
            } else if(this.grid === '4'){
                if(index === 4 || index === 9){
                    classes = 'pure-u-lg-2-4 full'
                }else{
                    classes = 'pure-u-lg-1-4'
                }
            }

            return classes
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Workshops.vue